import React from 'react';
import logo from '../../assets/logo.png';
import card from '../../assets/cards.png';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { storeAssigned } from '../../services/Methods/normalMethods';
import footerlogo from '../../assets/footer-image.png';
import ReactCountryFlag from 'react-country-flag';
import { useLocation } from "react-router-dom";


const Footer = (props) => {
    const { COMMON_TEXTS,showPopups,progress,data_display,currentIndex , orderFullList,userData} = props;

    const usePathname = () => {
            const location = useLocation();
            return location.pathname;
        };
        const path = usePathname();


    function _disclosureLink() {
        const { income_disclosure, shipping_disclosure, terms_condition, privacy, refund, procedures_policies, compensation } = COMMON_TEXTS;
        const FOOTER_LINK = ['income', 'shipping_info', 'terms', 'privacy', 'refund'];
        const TEXT = [income_disclosure, shipping_disclosure, terms_condition, privacy, refund, procedures_policies, compensation];
        return _.map(FOOTER_LINK, (row, index) => ({ link: `/${storeAssigned()}/${row}`, text: TEXT[index] }));
    }

    const LinkCss = "inline-block text-sm leading-[21px] text-white opacity-[0.65] transition-all eae-in-out duration-300 hover:opacity-100";

const keywordPricingMap = {
    'Mission Pack': {
      originalPrice: 147,
      discountedPrice: 99,
    },
    'Master Pack': {
      originalPrice: 735,
      discountedPrice: 500,
    },
    'Legacy Pack': {
      originalPrice: 1568,
      discountedPrice: 1000,
    },
  };


  const keywords = Object.keys(keywordPricingMap);

  const filteredItems = orderFullList.flatMap(order =>
    order.details
      .filter(detail =>
        keywords.some(keyword =>
          detail.itemDescr.toLowerCase().includes(keyword.toLowerCase())
        )
      )
      .map(detail => {
        const matchedKeyword = keywords.find(keyword =>
          detail.itemDescr.toLowerCase().includes(keyword.toLowerCase())
        );

        const pricing = keywordPricingMap[matchedKeyword];

        return {
          orderId: order.orderId,
          itemCode: detail.itemCode,
          itemDescr: detail.itemDescr,
          quantity: detail.quantity,
          userName: order.firstName+" "+order.lastName.charAt(0),
          countryCode: order.priceCountryCode,
          keyword: matchedKeyword,
          originalPrice: pricing.originalPrice,
          discountedPrice: pricing.discountedPrice,
          largeImage: detail.largeImage,
        };
      })
  );


    return (
        <div className="footer-container bg-[#2b3445] text-white pt-9">
            <div className="container max-w-[1260px] mx-auto px-[15px]">
                <div className="grid grid-cols-1 md:grid-cols-4 md:gap-[30px]">
                    <div className="text-center md:text-left md:mb-6 mb-12">
                        <a href="/" className='block max-w-[170px] -mt-1 mb-6 md:mx-0 mx-auto'>
                            <img src={footerlogo} alt="Logo" className="w-full h-full object-contain" />
                        </a>
                        <div className="credit-cards max-w-[190px] md:mx-0 mx-auto">
                            <img src={card} alt="Payment methods" className="w-full h-auto" />
                        </div>
                    </div>
                    <div className="text-center md:text-left mb-6">
                        <h4 className="text-2xl leading-[1.2] font-bold mb-4">{COMMON_TEXTS?.contact_us}</h4>
                        <p className="text-sm leading-[21px] mb-4 text-white opacity-[0.65]">
                            4106 CR 3706
                            <br /> Wills Point, Texas 75169
                        </p>
                        <a href="mailto:support@provizion.com" className="inline-block text-sm leading-[21px] mb-4 text-white opacity-[0.65] transition-all eae-in-out duration-300 hover:opacity-100">support@provizion.com</a>
                    </div>
                    <div className="text-center md:text-left mb-8">
                        <h4 className="text-2xl leading-[1.2] font-bold mb-4">{COMMON_TEXTS?.disclosure}</h4>
                        <ul className="">
                            {_.map(_disclosureLink(), ({ link, text }) => (
                                <li className="text-[0]" key={link}>
                                    <Link className={LinkCss + ' mb-1.5'} to={link}>{text}</Link>
                                </li>
                            ))}
                            <li className="text-[0]" >
                                <Link className={LinkCss + ' mb-1.5'} to="/pdf/Provizion_Global_P&P's3.7.25.pdf" target="_blank">
                                    Policies & Procedures
                                </Link>
                            </li>
                            <li className="text-[0]" >
                                <Link className={LinkCss} to="/api/Files/documents/Comp_Plan_Flier.pdf" target="_blank"> Compensation Plan</Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="border-[rgba(237,238,246,0.5)] border-[1px] px-5 py-[15px] max-w-[680px] mx-auto rounded-[2px] text-center mb-4">
                    <p className='text-xs text-white opacity-50 leading-[18px] font-normal'>{COMMON_TEXTS?.footer_discription}</p>
                </div>
                <div className="text-center pb-6">
                    <p className='text-xs text-white opacity-50 leading-[18px] font-normal'>© {(new Date().getFullYear())} Provizion. All rights reserved.</p>
                </div>
            </div>


            <div>
            
             {showPopups && (!userData || userData?.customerType === 4) && (path.includes('/tour') || path.includes('/Tour') || path?.includes('/longevity') || path?.includes('/Longevity') || path?.includes('/Prosperity') || path?.includes('/prosperity') || path?.includes('/destiny') || path?.includes('/Destiny') )&&(
                  <div className="products-popup-overlay">
                    <div className="products-popup-header">
                      <div className="products-progress-bar" style={{ width: `${progress}%` }} />
                    </div>
                    <div className="products-popup-content flex">
                      <div className='image'>
                          <img src={filteredItems[currentIndex]?.largeImage ? filteredItems[currentIndex]?.largeImage:filteredItems[currentIndex]?.largeImage} style={{width:"400px",height:"100px"}}/>
                      </div>
                      <div className='products-content' style={{lineHeight:"25px",paddingLeft:"10px"}}>
                      {filteredItems[currentIndex]?.userName} <ReactCountryFlag countryCode={filteredItems[currentIndex]?.countryCode || 'US'} style={{fontSize: '1.2rem', marginRight: '5px', marginLeft: '0.5rem'}} /> saved <span style={{color:"green"}}><strong>${filteredItems[currentIndex]?.originalPrice-filteredItems[currentIndex]?.discountedPrice}</strong></span> off wholesale by purchasing a {filteredItems[currentIndex]?.itemDescr} for <del style={{color:"red"}}>${filteredItems[currentIndex]?.originalPrice}</del> ${filteredItems[currentIndex]?.discountedPrice} 
                      {/* <button onClick={() => setShowPopup(false)} className="popup-close-button">X</button> */}
                      </div>
                    </div>
                  </div>
      
              )}
    </div>
        </div>

        

        // <>

        //     <footer className="bg-[#000000] py-[45px] relative z-[2]">
        //         <div className='container xl:max-w-[1380px] mx-auto px-[15px]'>
        //             <img className="flex mx-auto" src={footerlogo} alt="" />
        //             <div className="copy-div flex justify-center md:mt-[48px] mt-[30px]" >
        //                 <ul className="flex md:gap-[20px] gap-[10px] md:flex-nowrap flex-wrap md:justify-start justify-center">
        //                     <li className='md:w-auto w-full md:text-start text-center'> <a href="#" className=" text-[#fff] xl:text-[20px] md:text-[16px] text-[14px] font-light leading-[1]" >© Copyright 2025 Provizion Global LLC All Rights Reserved</a></li>
        //                     <li><a className="text-[#fff] xl:text-[20px] md:text-[16px] text-[14px] font-light leading-[1]" href="#"><span className="mr-[20px] md:inline-block  hidden">|</span> Privacy Policy</a></li>
        //                     <li><a className="text-[#fff] xl:text-[20px] md:text-[16px] text-[14px] font-light leading-[1]" href="#"><span className="md:mr-[20px] mr-[10px]">|</span>Terms of Use</a></li>
        //                 </ul>
        //             </div>
        //         </div>
        //     </footer>
        // </>
    );
}
export default Footer;